import { type FC } from "react"
import styled from "styled-components"

import { usePlatform } from "~/contexts/PlatformContext"
import { useUser } from "~/contexts/UserContext"

type Props = { certificate: { course: { title: string }; createDate: Date } }
const Certificate: FC<Props> = ({ certificate }) => {
	const platform = usePlatform().platform
	const user = useUser().user!

	return (
		<Content>
			<Title>Certificate of completion</Title>
			<Details>
				<Text>This is to certify that</Text>
				<Value>
					{user.firstName} {user.lastName}
				</Value>
				<Text>has successfully completed the course</Text>
				<Value>{certificate.course.title}</Value>
				<Text>on {new Intl.DateTimeFormat("en-US", { dateStyle: "long" }).format(certificate.createDate)}</Text>
			</Details>
			{platform.logo &&
				(platform.logo.isIcon ? (
					<Icon alt="Logo" src={platform.logo.filePath} />
				) : (
					<Logo alt="Logo" src={platform.logo.filePath} />
				))}
		</Content>
	)
}

const Content = styled.div`
	width: 100%;
	background-color: white;
	border: 10px solid ${props => props.theme.primaryColor};
	padding: 64px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 48px;
`

const Title = styled.h1`
	font-size: 32px;
	font-weight: bold;
	text-transform: uppercase;
	text-align: center;
`

const Details = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 24px;
`

const Text = styled.p`
	font-size: 20px;
	text-align: center;
`

const Value = styled.p`
	font-size: 28px;
	font-weight: 600;
	text-align: center;
`

const Icon = styled.img`
	width: 100px;
	height: 100px;
	object-fit: contain;
`

const Logo = styled.img`
	width: 500px;
	height: 50px;
	object-fit: contain;
`

export default Certificate
